import React from "react";
import PropTypes from "prop-types";
import StepResultFields from './StepResultFields'
import StepResultViewOnly from './StepResultViewOnly'

class CertificationType extends React.Component {
  render() {
    const {
      user,
      certificationType,
      certification,
      usersCertificationStepResults,
      programDirectors,
      instructorTrainers,
      trainingCenters,
      handlerAddStep,
      formUrl,
      handleCertificationUpdate,
      isSaiAdmin,
      viewOnly
    } = this.props;

    return (
      <React.Fragment>
        {this.displayCertificationType() &&
          <div className="panel panel-default is-open panel-certification" id={"certification-type-" + certificationType.id}>
            <div className="panel-body">
              <table className="table table-clean certification-table">
                <thead>
                  <tr>
                    <th>
                      <p>{certificationType.name} - {certification && certification.expiration_date ? `expires ${moment(certification.expiration_date).format("M/D/YYYY")}` : "uncertified"}</p>
                    </th>
                    <th>
                      <label>
                        Completed Date
                      </label>
                    </th>
                    <th>
                      <label>
                        Program Director
                      </label>
                    </th>
                    <th>
                      <label>
                        Instructor Trainer
                      </label>
                    </th>
                    <th>
                      <label>
                        Training Center
                      </label>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {certificationType.certification_steps.map((certificationStep, index) =>
                    <React.Fragment key={certificationStep.id}>
                      {usersCertificationStepResults[certificationStep.id] && usersCertificationStepResults[certificationStep.id].map((stepResult, index) =>
                        <tr key={`sr-${certificationStep.id}-${index}`}>
                          {this.displayStepResult(certificationStep, stepResult) &&
                            <React.Fragment>
                              {this.props.viewOnly == true ? (
                                <StepResultViewOnly
                                  key={`srvo-${certificationStep.id}-${index}`}
                                  stepResult={stepResult}
                                  certificationStep={certificationStep}
                                  programDirectors={programDirectors}
                                  instructorTrainers={instructorTrainers}
                                  trainingCenters={trainingCenters}
                                />
                              ) : (
                                <StepResultFields
                                  key={`srfe-${certificationStep.id}-${index}`}
                                  certificationStep={certificationStep}
                                  certification={certification}
                                  certificationType={certificationType}
                                  stepResult={stepResult}
                                  programDirectors={programDirectors}
                                  instructorTrainers={instructorTrainers}
                                  trainingCenters={trainingCenters}
                                  formType={stepResult.id ? "edit" : "new"}
                                  formUrl={formUrl}
                                  user={user}
                                  handleCertificationUpdate={handleCertificationUpdate}
                                  isSaiAdmin={isSaiAdmin}
                                  handlerAddStep={handlerAddStep}
                                  isLastOfStep={usersCertificationStepResults[certificationStep.id].length == index + 1}
                                />
                              )}
                            </React.Fragment>
                          }
                        </tr>
                      )}
                      {this.displayEmptyStep(certificationStep) &&
                        <tr>
                          <td>{certificationStep.name}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            {viewOnly == false &&
                              <button
                                className="btn btn-text"
                                onClick={() => { handlerAddStep(certificationStep) }}
                              >
                                ADD STEP
                              </button>
                            }
                          </td>
                        </tr>
                      }
                    </React.Fragment>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }

  displayCertificationType = () => {
    return (!this.props.certification || this.props.expandedView || this.props.certification.latest_sai_level)
  };

  displayStepResult = (certificationStep, stepResult) => {
    return (this.props.usersCertificationStepResults.hasOwnProperty(certificationStep.id) && (this.props.expandedView || stepResult.latest_sai_step))
  };

  displayEmptyStep = (certificationStep) => {
    return (!this.props.usersCertificationStepResults.hasOwnProperty(certificationStep.id))
  };
};

CertificationType.propType = {
  user: PropTypes.object,
  certificationType: PropTypes.object,
  usersCertificationStepResults: PropTypes.array,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  certification: PropTypes.object,
  handlerAddStep: PropTypes.func,
  formUrl: PropTypes.string,
  handleCertificationUpdate: PropTypes.func,
  isSaiAdmin: PropTypes.bool,
  expandedView: PropTypes.bool,
  viewOnly: PropTypes.bool
};

export default CertificationType;
